var WhooosReadingServices = require("lib/web/WhooosReadingServices");
var SSORosterReview = require("components/org/roster_upload/SSORosterReview");
var CurrentUser = require("lib/account/CurrentUser");
var Spinner = require("components/utility/Spinner");
var PendingTaskNotice = require("components/layout/PendingTaskNotice");

class CleverSync extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		LuckyOrangeClient.tagComponent("CleverSync");
		this.state = {
			loadingDataStores: false, rosterData: null
		};
		LuckyOrangeClient.tagComponent("CleverSync");
	}

	submitRoster(uploadData, callback) {
		var syncURL = WhooosReadingServices.SsoServer.url("/clever_sync");
		$.post(syncURL, uploadData);
	}

	finalizeRoster(updatedRosterData) {
		var accessToken = CurrentUser.getToken();

		var uploadData = {
			access_token: accessToken,
			roster_data: JSON.stringify(updatedRosterData),
			create: true
		};

		this.submitRoster(uploadData);

		var studentCount = 0;
		_.each(updatedRosterData, (section) => {
			studentCount += section.students.length;
		})
		this.props.onUpload(studentCount, false, PendingTaskNotice.CLEVER_SYNC);
	}

	render() {
		if (this.state.loadingDataStores) {
			var section = (
				<Spinner placeholder scale={ 1.7 } />
			);

		} else if (this.state.rosterData == null) {

			var syncURL = WhooosReadingServices.SsoServer.url("/clever_sync");

			if ($wr.isProduction()) {
				var cleverSsoUrl = "https://clever.com/oauth/authorize?response_type=code&redirect_uri=" + syncURL + "&client_id=7af64e2d8fcf51128936";
			} else {
				var cleverSsoUrl = "https://clever.com/oauth/authorize?response_type=code&redirect_uri=" + syncURL + "&client_id=a5b512fca82d417a64c9";
			}
			
			var accessToken = CurrentUser.getToken();

			cleverSsoUrl += "&state=" + accessToken;

			var section = (
				<div>
					<p className="text-center">
						Sync or update your roster by connecting your Clever account.
					</p>
					<p className="text-center">
						<a href={ cleverSsoUrl } className="btn buttonPrimary">
							Connect Clever
						</a>
					</p>
				</div>
			);

		} else {
			var section = (
				<div className="cleverStepTwo">
					<SSORosterReview rosterData={ this.state.rosterData }
						finalizeRoster={ this.finalizeRoster }
						method={ SSORosterReview.CLEVER_SYNC } />
				</div>
			)
		}

		return (
			<div className="cleverSync">
				{ section }
			</div>
		)
	}

	componentDidMount() {
		this.setState({ loadingDataStores: true });
		var embeds = "user.pending_data_stores";

		var userID = CurrentUser.get().id;
		CurrentUser.api().getUser(userID, { embed: embeds }, $wr.apiHandler((response) => {
			var cleverSyncStore = _.findWhere(response.user.pending_data_stores, {
				type: "clever-sync"
			});

			console.log(cleverSyncStore)

			if (cleverSyncStore) {
				this.setState({ rosterData: cleverSyncStore.data, loadingDataStores: false })
			} else {
				this.setState({ loadingDataStores: false })				
			}
		}));
	}
};

CleverSync.propTypes = StrictPropTypes({
	onUpload: PropTypes.func.isRequired
});

module.exports = CleverSync;



// WEBPACK FOOTER //
// ./modules/components/org/roster_upload/CleverSync.js